import { useContext } from 'react';
import { DialogsContext } from '../contexts/DialogsContext';

export const useDialogs = () => useContext(DialogsContext);

